var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 51,
    viewBox: "0 0 343 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 342.031 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 319.571 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 297.111 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 274.651 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 252.19 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 229.73 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 207.27 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 184.81 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 162.35 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 342.031 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 319.571 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 297.111 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 274.651 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 252.19 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 229.73 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 207.27 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 184.81 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 162.35 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 342.031 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 319.571 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 297.111 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 274.651 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 252.19 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 229.73 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 207.27 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 184.81 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 162.35 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 140.457 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 117.997 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 95.5366 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 73.0764 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 50.6162 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 28.156 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 5.69582 0)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 140.457 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 117.997 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 95.5366 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 73.0764 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 50.6162 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 28.156 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 5.69582 22.4609)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 140.457 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 117.997 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 95.5366 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 73.0764 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 50.6162 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 28.156 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.59156,
    cy: 2.59156,
    r: 2.59156,
    transform: "matrix(-1 0 0 1 5.69582 44.9219)",
    fill: "#0A1F8F",
    fillOpacity: 0.59
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.93d69b9a8d9013b83502c8a3ce79c263.svg";
export { ForwardRef as ReactComponent };